export default __webpack_public_path__ + "static/media/47VU683.d7653b31.png";